import { format } from 'date-fns';
import { defaultRange } from '../components/DatePicker';

export const shortTextFormat = (d: Date): string => {
  return format(d, 'MMM dd');
};

export const beginOfTodayAsUtcDate = (): Date => {
  const localDate = new Date();
  localDate.setHours(0, 0, 0, 0);
  const offset = localDate.getTimezoneOffset();
  return new Date(localDate.getTime() - offset * 60000);
};

export const endOfTodayAsUtcDate = (): Date => {
  const localDate = new Date();
  localDate.setHours(23, 59, 59, 0);
  const offset = localDate.getTimezoneOffset();
  return new Date(localDate.getTime() - offset * 60000);
};

export const fromTimezonedDateToUtcString = (d: Date, asFormat = 'yyyy-MM-dd'): string => {
  const offset = d.getTimezoneOffset();
  // Normalize the date as utc date
  const result = new Date(d.valueOf() - offset * 60 * 1000);
  return format(result, asFormat);
};

export const getDefaultDateRange = (): PredefinedDateRange => ({
  label: defaultRange.label,
  ...defaultRange.range(),
});

export const rangeToLabel = (d: DateRange | PredefinedDateRange): string => {
  if (isPredefinedRange(d)) {
    return d.label;
  }

  return `
        ${d.startDate !== undefined ? format(d.startDate, 'PP') : '?'}
        -
        ${d.endDate !== undefined ? format(d.endDate, 'PP') : '?'}`;
};

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

export interface PredefinedDateRange {
  startDate: Date;
  endDate: Date;
  label: string;
}

export const isPredefinedRange = (d: DateRange | PredefinedDateRange): d is PredefinedDateRange => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (d as any).label !== undefined;
};

export const toISOStringCET = (d: Date): string => {
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString();
};
